<template>
  <div>
    <label class="keywords-label">TYPE</label>
    <div class="dropdown">
      <v-select
        variant="outlined"
        v-model="selectedLibraryType"
        placeholder="Library Type"
        return-object
        outlined
        :items="libraryTypes"
        :menu-props="{ closeOnClick: true, closeOnContentClick: true }"
        :disabled="getUploadStatus"
      >
        <template #selection>
          <v-list-item class="dd-item">
            {{ selectedLibraryType.libraryType }}
          </v-list-item>
        </template>
        <template #item="{ item }">
          <v-list-item
            class="dd-item"
            @click="setLibraryType(item.value)"
          >
            {{ item.value.libraryType }}
        </v-list-item>
        </template>
      </v-select>
    </div>
  </div>
  <div class="dropdown-section">
    <label class="keywords-label">CATEGORY</label>
    <div class="dropdown">
      <v-select
      variant="outlined"
        v-model="selectedLibraryCategory"
        placeholder="Library Category"
        return-object
        outlined
        :items="libraryCategories"
        :menu-props="{ closeOnClick: true, closeOnContentClick: true }"
       :disabled="getUploadStatus"
      >
        <template #selection>
          <v-list-item
              class="dd-item"
          >
            {{ selectedLibraryCategory.libraryCategory }}
          </v-list-item>
        </template>
        <template #item="{ item }">
          <v-list-item
            class="dd-item"
            @click="setLibraryCategory(item.value)"
          >
            {{ item.value.libraryCategory }}
        </v-list-item>
        </template>
      </v-select>
    </div>
  </div>
</template>
  
<script>
import { useRMTStore } from '@/store/RMTStore';

export default {
  name: 'DropDown',
  data () {
    return {
      // selectedLibraryType: null,
      // selectedLibraryCategory: null
    };
  },
  setup () {
    const RMTStore = useRMTStore();
    return {
      RMTStore
    };
  },
  computed: {
    libraryTypes () {
      return this.RMTStore.libraryTypes;
    },
    libraryCategories () {
      return this.RMTStore.libraryCategories;
    },
    selectedLibraryType () {
      return this.RMTStore.libraryItemData.type;
    },
    selectedLibraryCategory () {
      return this.RMTStore.libraryItemData.category;
    },
    resourceLibraryType () {
      return this.selectedUploadedFileData.libraryType;
    },
    resourceLibraryCategory () {
      return this.selectedUploadedFileData.libraryCategory;
    },
    selectedUploadedFileData () {
      return this.RMTStore.getSelectedUploadedFileData;
    },
    getUploadStatus () {
      return !this.RMTStore.inUploadMode;
    }
  },
  methods: {
    setLibraryType (item) {
      // this.selectedLibraryType = item;
      this.RMTStore.setCurrentLibraryType(item);
    },
    setLibraryCategory (item) {
      // this.selectedLibraryCategory = item;
      this.RMTStore.setCurrentLibraryCategory(item);
    }
  }
};
</script>


<style>
.dd-item {
  font-size: .85em;
}

.v-field__input input {
  font-size: .85em;
  height: 35px;
  padding-left: 10px;
}

.v-field, .v-field__field, .v-field__input {
  min-height: 0px;
  height: 35px;
}

.v-field__input {
  padding: 0;
  color: black;
  background-color: white;
}

.v-field__append-inner {
  padding-top: 7px;
}

</style>
  
<style scoped>
.dropdown {
  width: 100%;
  /* height: 50px;
  border: 1px solid black; */
}
.v-field__field {
  height: 35px;
}

select {
  border: 1px solid black;
  border-radius: 5px;
  width: 50%;
  height: 50%;
  max-width: 250px;
  max-height: 100px
}

.select-placeholder {
  margin-left: 5px;
}

option:hover {
  background-color: pink;
}

/* .dropdown-section {
  padding-top: 1rem;
} */

</style>